import PropTypes from "prop-types";

function RankingMobile({ app, config }) {
  return <></>;
}

RankingMobile.defaultProps = {
  app: null,
  config: {},
};

RankingMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default RankingMobile;
